"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var polished_1 = require("polished");
var react_2 = require("react");
var loadingAnimation = react_1.keyframes({
    '0%': {
        backgroundPosition: '-468px 0',
    },
    '100%': {
        backgroundPosition: '468px 0',
    },
});
var styles = {
    container: function (color, delay) { return function (theme) { return react_1.css({
        animation: loadingAnimation,
        animationDuration: delay + "s",
        animationFillMode: 'forward',
        animationIterationCount: 'infinite',
        animationTimingFunction: 'linear',
        backgroundColor: '#f6f7f8',
        backgroundImage: "linear-gradient(to right, #eaeaea 8%, " + polished_1.rgba(color ||
            theme.color.PRIMARY.DEFAULT, 0.2) + " 38%, #eaeaea 54%)",
        backgroundSize: '1000px 640px',
        borderCollapse: 'collapse',
    }); }; },
    cell: react_1.css({
        border: '4px solid #fff',
    }),
};
var LoadingGrid = function (_a) {
    var _b = _a.rowCount, rowCount = _b === void 0 ? 5 : _b, _c = _a.colCount, colCount = _c === void 0 ? 3 : _c, _d = _a.width, width = _d === void 0 ? 600 : _d, _e = _a.height, height = _e === void 0 ? 300 : _e, _f = _a.gap, gap = _f === void 0 ? 4 : _f, _g = _a.color, color = _g === void 0 ? '' : _g, _h = _a.delay, delay = _h === void 0 ? 1.8 : _h;
    var rows = react_2.useMemo(function () { return new Array(rowCount).fill(undefined).map(function (val, idx) { return "row-" + idx; }); }, [rowCount]);
    var cols = react_2.useMemo(function () { return new Array(colCount).fill(undefined).map(function (val, idx) { return "col-" + idx; }); }, [colCount]);
    var containerStyle = react_2.useMemo(function () { return styles.container(color, delay); }, [color, delay]);
    return (react_1.jsx("table", { css: containerStyle, style: { width: width, height: height } },
        react_1.jsx("tbody", null, rows.map(function (row) { return (react_1.jsx("tr", { key: row }, cols.map(function (col) { return (react_1.jsx("td", { key: row + ":" + col, css: styles.cell, style: { borderWidth: gap } })); }))); }))));
};
exports.default = LoadingGrid;
